/**
 * RCC Surface #12 — Annual BSA/AML certification.
 *
 * Capture + log officer annual certification. Light UI — full training flow
 * lives in HR LMS; this surface records completion for audit.
 */

import { useState } from 'react';
import { useApiClient } from '@/contexts/ApiClientContext';
import { useAuth } from '@/contexts/AuthContext';
import { Button, Pill } from '@/components/primitives';
import { SurfaceHeader } from '../components/SurfaceHeader';

export function BsaAmlAnnual(): JSX.Element {
  const apiClient = useApiClient();
  const { user } = useAuth();
  const [certified, setCertified] = useState<boolean>(false);
  const [trainingId, setTrainingId] = useState<string>('');

  const certify = (): void => {
    void apiClient.retail.events
      .write({
        eventType: 'bsa-aml-annual-certified',
        eventCategory: 'compliance',
        severity: 'info',
        actor: user?.upn ?? 'unknown',
        payloadJson: JSON.stringify({ trainingId, certifiedAt: new Date().toISOString() }),
      })
      .catch(() => undefined);
    setCertified(true);
  };

  return (
    <div>
      <SurfaceHeader
        title="BSA/AML Annual Certification"
        scope="Record FSR annual BSA/AML certification. Training delivered via HR LMS; this surface captures completion for audit."
        surfaceNumber={12}
        role="FSR"
        actions={certified ? <Pill variant="ok">Certified</Pill> : <Pill variant="warn">Pending</Pill>}
      />
      <div style={{ display: 'grid', gap: 'var(--sp-5)', maxWidth: 520 }}>
        <div>
          <label
            htmlFor="bsa-training-id"
            style={{
              display: 'block',
              fontSize: 11,
              textTransform: 'uppercase',
              color: 'var(--ink-500)',
              marginBottom: 'var(--sp-3)',
            }}
          >
            LMS completion reference
          </label>
          <input
            id="bsa-training-id"
            type="text"
            value={trainingId}
            onChange={(e) => setTrainingId(e.target.value)}
            placeholder="e.g. LMS-BSA-2026-00123"
            style={{
              width: '100%',
              padding: 'var(--sp-4)',
              border: '1px solid var(--ink-300)',
              borderRadius: 'var(--r-md)',
              fontSize: 13,
            }}
          />
        </div>
        <Button
          variant="primary"
          onClick={certify}
          disabled={!trainingId.trim() || certified}
        >
          {certified ? 'Certification recorded' : 'Record certification'}
        </Button>
      </div>
    </div>
  );
}
